import React from "react";
import {  PageHeader, TeamMember } from "../../components";
import SwimmingGallery from "./directory/swimming";
import style from "./style.module.css";

export default function Swimming() {
  return (
    <div className="page-content">
      <PageHeader title="Swimming " page="swimming" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- contact --> */}
        <div className="content">
          <div class="section-full bg-gray content-inner ">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="/assets/images/section/Swimming/sw1.jpg"
                    alt=""
                    class="m-b30"
                  />
                </div>
                <div class="col-md-7 col-sm-12">
                  <h3 class="h2">WELCOME TO SWIMMING</h3>
                  <div class="dlab-separator bg-primary"></div>
                  <h4 class="font-weight-3 00">
                    Welcome to Swimming Section at the Lagos Country Club Ikeja.
                    Swimming is well acclaimed worldwide as the best form of
                    physical exercise of all parts of the body. By regularly
                    getting involved in swimming, you not only exercise but
                    ensure a healthy living as one the many benefits of
                    swimming.
                  </h4>
                  <p>
                    Tucked right in the heart of the Lagos Country Club, Ikeja,
                    is its sparkling crown jewel – the Swimming Section. With a
                    sleek 25-meter adult pool and a charming pea-shaped pool
                    where the little ones can splash, giggle, and make their
                    first big waves, it’s no surprise this section draws both
                    the young and the young-at-heart all year round.
                  </p>

                  <p>
                    Our pool pulses with energy. Whether you're mastering the
                    freestyle, joining a water aerobics class (think freestyle
                    dancing in the water!), or just playing Marco Polo with the
                    kids, our calendar keeps the whole family moving and
                    laughing – in the water and out!
                  </p>

                  <p>
                    Thinking of learning to swim? Our friendly and certified
                    coaches make learning safe and fun for kids (and adults
                    too!) Plus, with ever-watchful lifeguards always on duty,
                    parents can relax knowing safety is priority number one.
                  </p>

                  <p>
                    After the aquatic adventures, dry off and relax. With the
                    largest social space in the club, Swimming Section is
                    serviced by two bars and offers something for every vibe:
                    soak up the sun in the open-air area, unwind in the
                    air-conditioned cool room, or lounge in style on the breezy
                    covered terraces – both ground and first floor - perfect for
                    watching the kids play while you sip something refreshing.
                  </p>

                  <p>
                    So, whether you're racing laps, teaching a toddler to float,
                    or just soaking up the happy vibes, the Swimming Section
                    isn't just a part of the club – it's where family memories
                    are made, one splash at a time.
                  </p>

                  <p>
                    Dive in – quite literally – and join the movement.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}

        <SwimmingGallery />
        {/* <!-- Team member --> */}
        <TeamMember
          name="ENGR. DEJI OSHIKOYA"
          title="LCC CHAIRMAN SWIMMING"
          img="./assets/images/members/LCC_SWIMMING.jpg"
        />
        {/* <!-- Team member --> */}
      </div>
    </div>
  );
}
